<template>
  <div>Email cím megerősítése</div>
</template>

<script>
import config from '@/config'
import utils from '@/utils'
import notify from '@/notify'

export default {
  created: function () {
    let query = this.$route.query
    // eslint-disable-next-line no-prototype-builtins
    if (query.hasOwnProperty('t')) {
      let token = query.t

      this.$http({
        url: config.SERVER_DOMAIN + '/api/guest/emailconfirmation',
        method: 'POST',
        params: { ...this.$store.getters.getAuthParams, confirmToken: token },
        // eslint-disable-next-line no-unused-vars
      }).then(response => {
        console.log('--- email confirmation success')
        // eslint-disable-next-line
        notify.success('Sikeres Email-cím megerősítés')
      }, error => {
        utils.httpError(error)
      }).finally(() => {
        this.$router.push('Reservation')
      })
    } else {
      notify.warning('Hibás email hitelesítési link!')
      this.$router.push('Reservation')
    }
  },
}
</script>

<style scoped>

</style>
